<div class="error-dialog-container">   
    <div class="error-dialog">
        <mat-dialog-content class="content"> 
            <div class="message">
                {{ data.message }}
            </div>
            <textarea class="detail" disabled>{{ data.detail }}</textarea>
            
        </mat-dialog-content>
        <mat-dialog-actions class="close-button">
            <button mat-raised-button (click)="closeMe()" color="warn">Close</button>
        </mat-dialog-actions>
    </div>

    
</div>